<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/manage-assessments']" [queryParams]="{tab:tab}"><img src="assets/images/admin/backarrow.png" /> Back to Manage Assessment</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>

<div class="centerWrap mt-4 pt-2">
    <div class="adminInnerHead pt-2">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="userCouresLatest pb-2">
                    <div class="userCouresContent">
                        <h3>{{assessmentDetails?.assessment_name}}</h3>
                     <p>
                            <span>Created by: {{assessmentDetails?.created_by}} on
                                {{assessmentDetails?.created_dttm | date:'d MMM, y'}}</span>
                        </p>
                        <!-- <p>
                            <span>End Date: {{assessmentDetails?.end_date}}</span>
                            <a href="javascript:void(0);" class="btn-link" >EXTEND</a>
                        </p> -->
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="courseTabs">
                    <p>{{assessmentDetails?.course_desc}}</p>
                    <ul class="customTab">
                        <li><a href="javascript:void(0);" [routerLink]="['/view-assessment']"
                                [queryParams]="{id:assessmentDetails?.assessment_id,tab:tab}">VIEW</a> </li>

                        <!-- <li><a href="javascript:void(0);" [routerLink]="['/courses_view_user']"
                                [queryParams]="{id:assessment_id,tab:tab}">VIEW USERS</a> </li> -->
                        <li><a href="javascript:void(0);" 
                                [routerLink]="['/view-user']"
                                [queryParams]="{id:assessmentDetails?.assessment_id,tab:tab}">ASSIGNED TO
                                (USERS)</a> </li>
                        <li><a href="javascript:void(0);" class="active"
                                [routerLink]="['/assign-users']"
                                [queryParams]="{id:assessmentDetails?.assessment_id,tab:tab}">ASSIGN USERS</a> </li>
                        <li *ngIf="assessmentDetails.assigned_users==0"><a href="javascript:void(0);" [routerLink]="['/create-assessment']"
                                [queryParams]="{assId:assessmentDetails?.assessment_id,tab:tab}" >EDIT</a> </li>
                        <li><a href="javascript:void(0);" (click)="open(duplicate)">DUPLICATE</a> </li>
                        <li class="deactiveTab" *ngIf="assessmentDetails?.is_active==1"><a href="javascript:void(0);"
                                (click)="open(deactivate)">DEACTIVATE</a> </li>
                        <li class="deactiveTab" *ngIf="assessmentDetails?.is_active==0"><a href="javascript:void(0);"
                                (click)="open(activate)">ACTIVATE</a> </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    
    <div class="formHeading pr-0">
        <div class="row m-0">
            <div class="col-12 col-md-4">
        <h2>Assign Assessment</h2>
        <p>Select 1 or more users from the list to assign this assessment. </p>
    </div>
    <div class="col-12 col-md-4">
        <div class="filterWrap">
            <div class="searchWrap mr-0">
                <input type="text" placeholder="Search Users" #searchUser>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-4">
        <div class="filterSelect">
            <span>Filter by Organisation:</span>
            <div class="selectCustom w-auto">
                <select (change)="selectChangeHandler($event)">
                    <option value='0'>All</option>
                    <option *ngFor="let organisation of organisationData" [value]="organisation.organisation_id">{{organisation.org_name}}</option>
                    <!-- <option value='2'>eastern railway</option>
                    <option value='5'>southern railway</option>
                    <option value='6' >north-west railway</option>
                    <option value='7'>north-west railway</option> -->
                </select>
              
            </div>
        </div>
    </div>
        </div>
    </div>

    <ngx-spinner>
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <div class="tableWrap">
        <table  matSort (matSortChange)="sortData($event)">
            <thead>
                <tr>
                    <th class="assignUser">
                    <div class="customCheck">
                        <mat-checkbox id="all" [ngModel]="isCheckeds"  [checked]="false" (change)="onChange($event)">ALL</mat-checkbox>
                    </div>
                    </th>
                    <th><div mat-sort-header="first_name"><b></b> Users</div></th>
                    <th>Email ID</th>
                    <th>Phone Number</th>
                    <th mat-sort-header="organisation_name">Organisation</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let values of userData; let i = index">
                    <td *ngIf="values.courses_assigned_list.indexOf(courseIdNum) != -1">
                        <div class="customCheck">
                            <mat-checkbox color="primary" [ngModel]="values?.checked "  (change)="onChangeDemo($event,values.user_id,i)" [disabled]="true" [checked]="false" ></mat-checkbox>
                        </div>
                    </td>
                    <td *ngIf="values.courses_assigned_list.length == 0 || values.courses_assigned_list.indexOf(courseIdNum) == -1">
                        <div class="customCheck">
                            <mat-checkbox [ngModel]="values?.checked " (change)="onChangeDemo($event,values.user_id,i)" ></mat-checkbox>
                        </div>
                    </td>
                    <td>
                        <div class="userTdWrap">
                            <span>{{values.first_name}} {{values.last_name}}</span>
                            <b>Created on {{values.created_dttm}}</b>
                        </div>
                    </td>
                    <td>
                        {{values.email}}
                    </td>
                    <td>{{values.phone}}</td>
                    <td>{{values.organisation_name}}</td>
                </tr>
             </tbody>
        </table>

        <div class="text-center">
            <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="open(content)" [ngClass]="(selectUserId.length < 1 ) ? 'btn btn-primary btn-sm disable ' :
            'btn btn-primary btn-sm' ">Assign Users To Assessment</a>
        </div>
    </div>


</div>

<ng-template #activate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Activate course</h6>
                <p class="size18">Are you sure you want to activate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="changeIsDeActiveVal(1)"
                    >Yes, Activate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #duplicate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Duplicate course</h6>
                <p class="size18">Are you sure you want to duplicate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm"
                    (click)="duplicateCourse()">Yes, Duplicate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #deactivate let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>DeActivate course</h6>
                <p class="size18">Are you sure you want to deactivate this course?</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                    cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="changeIsDeActiveVal(0)"
                    >Yes, DeActivate</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #content let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <h6>Assign Users</h6>
            <p class="size18">Are you sure you want to assign it to the users selected?</p>
            <input type="hidden" (click)="modal.dismiss('Cross click')" id="CloseIds">
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="modal.dismiss('Cross click')">No,
                cancel</a>
            <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="publish()">Yes, Assign</a>
        </div>
    </div>
</ng-template>